import { defineStore } from "pinia"
import { MemberSubscription } from "@vitable/asclepius-api-client-ts"

export interface SubscriptionState {
  activeSubscriptions: Array<MemberSubscription>
}

export const useSubscriptionStore = defineStore("subscriptionStore", {
  persist: true,
  state: (): SubscriptionState => {
    return {
      activeSubscriptions: []
    }
  },
  getters: {
    hasActiveSubscription(): boolean {
      return !!this.activeSubscriptions.length
    }
  },
  actions: {
    setActiveSubscriptions(activeSubscriptions: Array<MemberSubscription>) {
      this.activeSubscriptions = activeSubscriptions
    }
  }
})
